export default __webpack_public_path__ + "static/media/hand-with-increase-arrow.bae1aa5f.svg";